module.exports = __webpack_public_path__ + "static/media/chronic_disease_medication.43ceb6ae.svg";